import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@material-ui/core'
import { tr } from 'utils/translations/translate'
import { TEXT_CANCEL } from 'utils/translations/keys'

type BillingDialogProps = {
    title: string
    open: boolean
    okText: string
    handleClose: () => void
    handleOk: () => void
    showOk?: boolean
    loading?: boolean
}
export const BillingDialog: React.FC<BillingDialogProps> = (props) => {
    const { title, open, handleClose, handleOk, okText, showOk = true, loading = false } = props
    return (
        <Dialog open={open}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent style={{ width: '480px' }}>{props.children}</DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit" disabled={loading}>
                    {tr(TEXT_CANCEL)}
                </Button>
                {showOk && (
                    <Button
                        onClick={handleOk}
                        color="primary"
                        autoFocus
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
                    >
                        {okText}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}
